var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { active: _vm.feedbackVisible }, attrs: { id: "feedback" } },
    [
      _c("div", { staticClass: "floating-actions" }, [
        _c(
          "button",
          {
            staticClass: "floating-button background-color-ui-primary",
            attrs: {
              "data-tip": _vm.t("app-give-feedback"),
              "aria-label": _vm.t("app-give-feedback"),
              type: "button",
            },
            on: {
              click: function ($event) {
                _vm.feedbackVisible = !_vm.feedbackVisible
              },
            },
          },
          [
            !_vm.feedbackVisible
              ? _c("span", { staticClass: "material-icons" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "24px",
                        viewBox: "0 0 24 24",
                        width: "24px",
                      },
                    },
                    [
                      _c("path", {
                        attrs: { d: "M0 0h24v24H0z", fill: "none" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z",
                        },
                      }),
                    ]
                  ),
                ])
              : _c("span", { staticClass: "material-icons" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "24px",
                        viewBox: "0 0 24 24",
                        width: "24px",
                      },
                    },
                    [
                      _c("path", {
                        attrs: { d: "M0 0h24v24H0V0z", fill: "none" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z",
                        },
                      }),
                    ]
                  ),
                ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { id: "feedback-modal" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitFeedback.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "modal-header-heading" }, [
              _vm._v(_vm._s(_vm.t("app-give-feedback-heading"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-header-message" }, [
              _vm._v(_vm._s(_vm.t("app-give-feedback-message"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-email" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email",
                },
              ],
              attrs: { type: "email", placeholder: "Email", required: "" },
              domProps: { value: _vm.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-textarea" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.message,
                  expression: "message",
                },
              ],
              attrs: { placeholder: "Message", required: "" },
              domProps: { value: _vm.message },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.message = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("button", { staticClass: "compact" }, [
            _vm._v(_vm._s(_vm.t("app-submit"))),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }